import React from "react";
import { Modal, Button } from "react-bootstrap";
import PuffLoader from "react-spinners/PuffLoader";

const ModalFooter = (props) => {
  const handleCancelButtonClick = () => {
    if (props.mode === "add" || props.mode === "remove" || props.mode === "quickAdd") {
      props.onHide();
    } else if (props.mode === "update") {
      props.resetUserValuesAndClose();
    }
  };

  return (
    <Modal.Footer>
      <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
        <Button
          type="button"
          data-testid="delete-modal-no-button"
          variant="secondary"
          onClick={handleCancelButtonClick}
        >
          Cancel
        </Button>
        {props.submitLoading ? (
          <PuffLoader size={40} color={"black"} loading={true} />
        ) : (
          <Button
            type="button"
            data-testid="delete-modal-delete-button"
            disabled={props.submitLoading}
            variant="primary"
            onClick={() => {
              props.onSubmitClick();
            }}
          >
            {props.mode === "quickAdd" ? "Add" : "Submit"}
          </Button>
        )}
      </div>
    </Modal.Footer>
  );
};

export default ModalFooter;
